import { heroStats } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <div className="absolute top-0 right-0 w-full md:w-1/2 h-full bg-gradient-to-l from-primary-100/30 to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent-100/20 rounded-full blur-3xl"></div>
        <div className="absolute top-20 right-1/4 w-64 h-64 bg-primary-100/15 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-24 pb-16 md:pb-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-fire-line text-base"></i>
              <span className="whitespace-nowrap">全网娱乐资讯聚合平台</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight mb-4">
              吃瓜在线
              <span className="block text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-700 mt-2">
                一站聚合 · 全网吃瓜
              </span>
            </h1>

            <p className="text-foreground-500 text-base md:text-lg leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-4">
              吃瓜在线整合51吃瓜在线、91吃瓜在线、17吃瓜在线等多平台入口，为全网吃瓜群众提供最新、最全的娱乐资讯与八卦内容。
              涵盖明星动态、影视综艺、音乐时尚、网红生态、国际娱乐等30余个品类，每日更新超过200条热点资讯。
            </p>
            <p className="text-foreground-500 text-base md:text-lg leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              本站持续维护各个吃瓜入口的最新地址，确保用户随时随地快速访问。当前正持续追踪多起娱乐圈重磅事件的最新进展，
              包括顶流恋情风波、热播剧终局热议以及年度综艺收视格局变动等热门话题。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-black text-primary-500 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-400 mt-1 whitespace-nowrap">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 text-base cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                浏览热门速递
              </a>
              <a
                href="#index"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-background-100 text-foreground-700 font-medium rounded-lg hover:bg-background-200 transition-colors duration-200 text-base border border-background-200 cursor-pointer"
              >
                <i className="ri-stack-line"></i>
                查看专题索引
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/5] md:aspect-[5/4] lg:aspect-[4/5] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20modern%20digital%20entertainment%20and%20social%20media%20gossip%20culture%2C%20abstract%20geometric%20shapes%20in%20warm%20coral%20and%20gold%20tones%2C%20floating%20chat%20bubbles%20and%20notification%20icons%2C%20trending%20hashtag%20symbols%2C%20dynamic%20composition%20with%20soft%20gradient%20background%20in%20cream%20and%20warm%20white%2C%20editorial%20digital%20art%20style%20with%20clean%20lines%20and%20subtle%20texture%2C%20high%20contrast%20between%20foreground%20elements%20and%20light%20background%2C%20contemporary%20web%20design%20aesthetic&width=700&height=875&seq=hero-visual&orientation=portrait"
                alt="吃瓜在线娱乐资讯聚合平台主视觉 - 展示全网八卦娱乐内容"
                title="吃瓜在线 - 全网娱乐资讯聚合平台"
                className="w-full h-full object-cover object-top"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}